import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify'
import { useConfig } from '@peracto/peracto-config'
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { Formik } from 'formik'
import { on } from 'events'

const Form = props => {
    const { onSubmit, children, reCaptchaToken, setReCaptchaToken, ...restProps } = props

    const config = useConfig()
    const { content } = config.get('features', {})

    const { executeRecaptcha } = useGoogleReCaptcha()

    const [formData, setFormData] = useState(null)

    useEffect(() => {
        if (content?.reCaptcha && reCaptchaToken) onSubmit(formData)
    }, [reCaptchaToken])

    return (
        <>
            {content?.reCaptcha ? (
                <Formik
                    onSubmit={async data => {
                        setFormData(data)
                        await executeRecaptcha()
                            .then(async token => {
                                if (!token) {
                                    onSubmit(data)
                                } else {
                                    setReCaptchaToken(token)
                                }
                            })
                            .catch(err => {
                                console.log('err', err)
                            })
                    }}
                    {...restProps}
                >
                    {children}
                </Formik>
            ) : (
                <Formik
                    onSubmit={async data => {
                        await executeRecaptcha().then(async token => {
                            if (token)
                                await axios
                                    .post('/api/recaptcha', {
                                        token,
                                    })
                                    .then(() => {
                                        onSubmit(data)
                                    })
                                    .catch(e => {
                                        console.error('Error:', e)
                                        toast.error([e?.response?.data?.errorMessage])
                                        throw new Error(e)
                                    })
                        })
                    }}
                    {...restProps}
                >
                    {children}
                </Formik>
            )}
        </>
    )
}

// Bundlers only inline the exact `process.env.NAME` form (there is no `process` global in the
// browser with webpack 5), so read it plainly and fall back if nothing was inlined
const getRecaptchaKey = () => {
    try {
        return process.env.NEXT_PUBLIC_RECAPTCHA_KEY
    } catch (e) {
        return undefined
    }
}

export const RecaptchaForm = props => {
    const recaptchaKey = getRecaptchaKey()

    if (recaptchaKey) {
        return (
            <GoogleReCaptchaProvider reCaptchaKey={recaptchaKey}>
                <Form {...props} />
            </GoogleReCaptchaProvider>
        )
    } else {
        return <Formik {...props} />
    }
}
